/**
 * Makes jQuery available globally and installs jquery-migrate since some WP plugins need it.
 * In functions.php we exclude the jquery WordPress normally provides.
 */

// JQuery
import * as $ from 'jquery';

// Import jquery-migrate
($ as any).migrateMute = true; // Disable jQuery migrate logging
import 'jquery-migrate'; // (needs to take place after setting mute to true)

// Add jQuery as a global
declare global {
	interface Window {
		jQuery: JQueryStatic;
		$: JQueryStatic;
	}
}
window.jQuery = $;
window.$ = $;

export default $;